var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderRetrieval" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": _vm.headShow,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c(
        "div",
        { staticClass: "order-retrieval" },
        [
          _vm.active == 1
            ? _c(
                "div",
                { staticClass: "order-retrieval-one order-retrieval-common" },
                [
                  _c(
                    "div",
                    { staticClass: "order-retrieval__step" },
                    [
                      _c(
                        "van-form",
                        { ref: "parentFrom" },
                        [
                          _c("van-field", {
                            staticClass: "radio",
                            staticStyle: { "border-radius": "16px 16px 0 0" },
                            attrs: {
                              name: "os",
                              label: "操作系统：",
                              rules: [
                                { required: true, message: "请选择操作系统" }
                              ]
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function() {
                                    return [
                                      _c(
                                        "van-radio-group",
                                        {
                                          attrs: { direction: "horizontal" },
                                          model: {
                                            value: _vm.orderParams.os,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.orderParams,
                                                "os",
                                                $$v
                                              )
                                            },
                                            expression: "orderParams.os"
                                          }
                                        },
                                        [
                                          _c(
                                            "van-radio",
                                            { attrs: { name: "1" } },
                                            [_vm._v("安卓官方")]
                                          ),
                                          _c(
                                            "van-radio",
                                            { attrs: { name: "2" } },
                                            [_vm._v("雷霆iOS")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2409757345
                            )
                          }),
                          _c("van-field", {
                            staticClass: "lt-freeze-select",
                            staticStyle: { "border-radius": "0 0 16px 16px" },
                            attrs: {
                              name: "game",
                              label: "所玩游戏：",
                              placeholder: "请选择您所玩的游戏",
                              rules: [
                                {
                                  required:
                                    _vm.orderParams.os === "210009"
                                      ? true
                                      : false,
                                  message: ""
                                }
                              ]
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function() {
                                    return [
                                      _c("common-select", {
                                        attrs: {
                                          "selection-info": {
                                            selectName: "",
                                            columns: _vm.columns,
                                            label: "name",
                                            val: "game"
                                          }
                                        },
                                        on: { emitParentVal: _vm.emitParentVal }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              4006239139
                            )
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "check-order-tips",
                              on: { click: _vm.checkOrderTips }
                            },
                            [_vm._v("查看商户订单的方式？")]
                          ),
                          _c("van-field", {
                            staticClass: "lt-freeze-select",
                            staticStyle: { "border-radius": "16px 16px 0 0" },
                            attrs: {
                              name: "year",
                              label: "充值年份：",
                              placeholder: "请选择您的充值年份",
                              rules: [{ required: false, message: "" }]
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function() {
                                    return [
                                      _c("common-date", {
                                        attrs: {
                                          "web-date-type": "year",
                                          "picker-options": _vm.pickerOptions,
                                          "min-date": new Date(2019, 0, 1),
                                          "selection-info": { selectName: "" }
                                        },
                                        on: { emitTimeVal: _vm.emitTimeVal }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2768090500
                            )
                          }),
                          _c("van-field", {
                            staticStyle: { "border-radius": "0 0 16px 16px" },
                            attrs: {
                              label: "商户订单：",
                              placeholder: "请输入商户订单号"
                            },
                            model: {
                              value: _vm.orderParams.orderNo,
                              callback: function($$v) {
                                _vm.$set(_vm.orderParams, "orderNo", $$v)
                              },
                              expression: "orderParams.orderNo"
                            }
                          }),
                          _c("van-field", {
                            staticStyle: {
                              "border-radius": "16px 16px 0 0",
                              "margin-top": "0.32rem"
                            },
                            attrs: {
                              label: "手机号",
                              placeholder: "请输入能联系到您的手机号"
                            },
                            model: {
                              value: _vm.orderParams.phoneNum,
                              callback: function($$v) {
                                _vm.$set(_vm.orderParams, "phoneNum", $$v)
                              },
                              expression: "orderParams.phoneNum"
                            }
                          }),
                          _c("van-field", {
                            staticStyle: { "border-radius": "0 0 16px 16px" },
                            attrs: {
                              maxlength: "6",
                              label: "短信验证码",
                              rules: _vm.rules.codeRules,
                              placeholder: "请输入验证码"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button",
                                  fn: function() {
                                    return [
                                      !_vm.showTime
                                        ? _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                color: "#616edf",
                                                cursor: "pointer"
                                              },
                                              on: { click: _vm.getCode }
                                            },
                                            [_vm._v(_vm._s(_vm.timeMsg))]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                color: "#878787",
                                                cursor: "pointer"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.codeTime) + " S"
                                              )
                                            ]
                                          )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              895199067
                            ),
                            model: {
                              value: _vm.orderParams.phoneCode,
                              callback: function($$v) {
                                _vm.$set(_vm.orderParams, "phoneCode", $$v)
                              },
                              expression: "orderParams.phoneCode"
                            }
                          }),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.$isFlag,
                                  expression: "!$isFlag"
                                }
                              ],
                              staticClass: "order-retrieval__codetips"
                            },
                            [
                              _vm._v(
                                " *如果在1分钟内没有收到短信验证码请重新获取 "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "bottom" },
                            [
                              _c(
                                "van-button",
                                {
                                  staticClass: "formClass_btn",
                                  attrs: {
                                    round: "",
                                    block: "",
                                    type: "info",
                                    color: "#616edf"
                                  },
                                  on: { click: _vm.onSubmitOrder }
                                },
                                [_vm._v("下一步")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.active === 2
            ? _c("div", { staticClass: "order-retrieval-two" }, [
                !_vm.bindPhoneListEncrypted.length
                  ? _c("h5", [
                      _vm._v("亲爱的玩家，您当前的订单号未绑定雷霆账号。")
                    ])
                  : _c("div", [
                      _c("h5", [
                        _vm._v("亲爱的玩家，您当前订单号查询到的雷霆账号：")
                      ]),
                      _c(
                        "ul",
                        [
                          _c("li", [_vm._v("雷霆账号")]),
                          _vm._l(_vm.bindPhoneListEncrypted, function(item, i) {
                            return _c("li", { key: i }, [_vm._v(_vm._s(item))])
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "bottom" },
                        [
                          _c(
                            "van-button",
                            {
                              staticClass: "formClass_btn",
                              attrs: {
                                round: "",
                                block: "",
                                plain: "",
                                type: "info",
                                color: "#616edf"
                              },
                              on: {
                                click: function($event) {
                                  _vm.active = 3
                                }
                              }
                            },
                            [_vm._v("查看完整账号")]
                          )
                        ],
                        1
                      ),
                      _vm._m(0)
                    ])
              ])
            : _vm._e(),
          _vm.active === 3
            ? _c(
                "van-form",
                { staticClass: "order-retrieval-three" },
                [
                  _c("van-field", {
                    staticStyle: { "border-radius": "16px 16px 0 0" },
                    attrs: {
                      label: "真实姓名",
                      rules: _vm.rules.nameRules,
                      placeholder: "请输入姓名"
                    },
                    model: {
                      value: _vm.formParams.name,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "name", $$v)
                      },
                      expression: "formParams.name"
                    }
                  }),
                  _c("van-field", {
                    staticStyle: { "border-radius": "0 0 16px 16px" },
                    attrs: {
                      label: "身份证号码",
                      rules: _vm.rules.idRules,
                      placeholder: "请输入身份证号码"
                    },
                    model: {
                      value: _vm.formParams.idCard,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "idCard", $$v)
                      },
                      expression: "formParams.idCard"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "bottom" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            color: "#616edf"
                          },
                          on: { click: _vm.checkByIdentity }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.active === 4
            ? _c("div", { staticClass: "order-retrieval-four" }, [
                _c("h5", [
                  _vm._v(
                    _vm._s(
                      "亲爱的玩家，您当前查询账号实名与填写身份证匹配的有" +
                        _vm.usernameListByIdentity.length +
                        "个："
                    )
                  )
                ]),
                _c(
                  "ul",
                  [
                    _c("li", [_vm._v("雷霆账号")]),
                    _vm._l(_vm.usernameListByIdentity, function(item, i) {
                      return _c("li", { key: i }, [_vm._v(_vm._s(item))])
                    })
                  ],
                  2
                ),
                _vm.hideUsernameList.length
                  ? _c("h5", [
                      _vm._v(
                        "以下账号实名信息与填写的身份证信息不一致，无法告知完整的雷霆账号："
                      )
                    ])
                  : _vm._e(),
                _c(
                  "ul",
                  _vm._l(_vm.hideUsernameList, function(item, i) {
                    return _c("li", { key: i }, [_vm._v(_vm._s(item))])
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "bottom" },
                  [
                    _c(
                      "van-button",
                      {
                        staticClass: "formClass_btn",
                        attrs: {
                          round: "",
                          block: "",
                          plain: "",
                          type: "info",
                          color: "#616edf"
                        },
                        on: {
                          click: function($event) {
                            _vm.active = 3
                          }
                        }
                      },
                      [_vm._v("重新填写身份信息")]
                    )
                  ],
                  1
                ),
                _vm._m(1)
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order-retrieval-two__tips" }, [
      _c("span", [_vm._v("温馨提示：")]),
      _c("p", [
        _vm._v(
          "1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。"
        )
      ]),
      _c("p", [_vm._v("2.若您已记起完整的账号，可以找回您的账号密码。")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order-retrieval-four__tips" }, [
      _c("span", [_vm._v("温馨提示：")]),
      _c("p", [
        _vm._v(
          "1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。"
        )
      ]),
      _c("p", [_vm._v("2.若您已记起完整的账号，可以找回您的账号密码。")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }